import * as angular from 'angular';
import {ConfigScope} from "./config.base";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsEnums} from "../../shared/dto/aps.enums";
import template from './checkDetectorConfig.tpl.html';
import UIUtilityServiceName, {EnumOption, UIUtilityService} from "../../services/utility/uiUtility.service";

interface CheckDetectorConfigScope extends ConfigScope {
  versions: EnumOption[];
  aiServers: apsViewModels.EquipmentDetail[];
}

export default angular.module('aps.controller.checkDetectorConfig', [])
  .directive('apsCheckDetectorConfig', (uiUtilityService: UIUtilityService): angular.IDirective => {
    return {
      restrict: 'E',
      template: template,
      link: (scope: CheckDetectorConfigScope) => {
        scope.aiServers = scope.vm.allEquipment.filter(e => e.type === apsEnums.EquipmentType.AIServer);
        scope.versions = uiUtilityService.getListOptionsFromEnum(apsEnums.CheckDetectorVersion);
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/equipment/checkDetectorConfig.directive.ts